import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Select from "react-select";


export default class DispatcherDailyActivities extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = "GET_DAILY_GAPS";
		this.state = {
			...this.state,
			search: "",
			selectedUsers: [],
			users: []
		}
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getUsers();
	}

	handleUsers = async (value) => {
		let users = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				users.push(value[i]);
			}
			this.state.selectedUsers = users;
			this.setState({selectedUsers: users})
		} else {
			this.state.selectedUsers = [];
		}

		//update filter and recall for data
		this.model.filter = {users: this.state.selectedUsers.map((user) => user.value)};
		this.state.filter = {users: this.state.selectedUsers.map((user) => user.value)};
		this.data = await this.model.submit(null, "GET_DAILY_GAPS");
		this.state.pages = Math.ceil(this.data.total / 20);
		this.data = this.data.items;
		this.setState({data: this.data, pages: this.state.pages});
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		userModel.limit = 500;
		try {
			this.users = await userModel.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];

			this.setState({
				users: this.users
			});

			let usersPkeys = window.location.href.includes("?:") ? [parseInt(window.location.href.split('?:')[1])] : [];
			let selected = this.users.filter(item => usersPkeys.includes(item.pkey));
			//if 0, then the users are already in the format we need
			if (selected.length !== 0) {
				let selectedUsers = selected.map((user) => {
					return {value: user.pkey, label: user.name_first + " " + user.name_last}
				});
				await this.handleUsers(selectedUsers)
			}

		} catch (error) {
			console.log(error, 'error')
		}
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		columns = [
			{
				Header: "Dispatcher",
				id: "name",
				accessor: obj => obj.name
			},
			{
				Header: "Time Created",
				id: "created",
				accessor: obj => moment(obj.created).local().format('MM/DD/YYYY h:mm A'),
			},
			{
				Header: "Respond Time",
				id: "modified",
				accessor: obj => moment(obj.modified).local().format('MM/DD/YYYY h:mm A')
			},
			{
				Header: "Total Gap Time",
				id: "time",
				accessor: obj => {
					const duration = moment.duration(moment(obj.modified).diff(moment(obj.created)));

					let timeString = '';
					if (duration.hours() > 0) {
						timeString += `${duration.hours()}h `;
					}
					if (duration.minutes() > 0 || duration.hours() > 0) {
						timeString += `${duration.minutes()}m `;
					}
					timeString += `${duration.seconds()}s`;

					return timeString.trim();
				}
			},
			{
				Header: "Reasoning",
				id: "reasoning",
				accessor: obj => obj.reasoning
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Daily Gaps', '')}
							<div className={"col-4"}>
								<Select
									key={this.state.selectedUsers}
									placeholder={"User Select"}
									isMulti
									isClearable
									value={this.state.selectedUsers.map(user => {
										return (
											{value: user.value, label: user.label})
									})}
									onChange={this.handleUsers}
									options={this.state.users.map(user => {
										return (
											{value: user.pkey, label: user.name_first + " " + user.name_last})
									})}
								/>
							</div>
							{this.renderHeaderRight("Daily Gaps", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
